import axios from "axios";
import { getAccessToken } from "./utils";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { gettingStartedProgress } from "./globalAction";
// import { dispatch } from "d3";
import store from "../store";

export const GET_SETTINGS = "GET_SETTINGS";
export const ALERT_FIELD_VALUE_CHANGE = "ALERT_FIELD_VALUE_CHANGE";
export const ALERT_RESET_FIELD_VALUE = "ALERT_RESET_FIELD_VALUE";
export const REPORT_FIELD_VALUE_CHANGE = "REPORT_FIELD_VALUE_CHANGE";
export const REPORT_RESET_FIELD_VALUE = "REPORT_RESET_FIELD_VALUE";
export const CREATE_ALERT = "CREATE_ALERT";
export const TOPICS_OPTIONS = "TOPICS_OPTIONS";
export const REPORT_TYPE_OPTIONS = "REPORT_TYPE_OPTIONS";
export const ALERT_TYPE_OPTIONS = "ALERT_TYPE_OPTIONS";
export const LOCATION_OPTIONS = "LOCATION_OPTIONS";
export const EDIT_REPORT_ITEM = "EDIT_REPORT_ITEM";
export const EDIT_ALERT_ITEM = "EDIT_ALERT_ITEM";
export const PLATFORM_OPTIONS = "PLATFORM_OPTIONS";
export const CUSTOM_DASHBOARD_OPTIONS = "CUSTOM_DASHBOARD_OPTIONS";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const EDIT_ALERT = "EDIT_ALERT";
export const EDIT_ALERT_VALUES = "EDIT_ALERT_VALUES";
export const CREATE_REPORT = "CREATE_REPORT";
export const UPDATE_REPORT = "UPDATE_REPORT";
export const DELETE_REPORT = "DELETE_REPORT";
export const DELETE_REPORT_PROMPT = "DELETE_REPORT_PROMPT";
export const EDIT_REPORT = "EDIT_REPORT";
export const EDIT_REPORT_VALUES = "EDIT_REPORT_VALUES";
export const GET_REPORTS_LIST = "GET_REPORTS_LIST";
export const GET_ALERTS_LIST = "GET_ALERTS_LIST";
export const RESET_REPORT_FORM = "RESET_REPORT_FORM";
export const RESET_ALERT_FORM = "RESET_ALERT_FORM";
export const ENABLE_OR_DISABLE_ALERT = "ENABLE_OR_DISABLE_ALERT";
export const DISABLE_ALERT = "DISABLE_ALERT";
export const SET_DEFAULT_EMAIL = "SET_DEFAULT_EMAIL";

export const alertFieldValueChange = (field, value) => {
    return {
        type: ALERT_FIELD_VALUE_CHANGE,
        field,
        value,
    };
};

export const resetAlertFieldValue = (field) => {
    return {
        type: ALERT_RESET_FIELD_VALUE,
        field,
    };
};

export const resetAlertForm = () => {
    return {
        type: RESET_ALERT_FORM,
    };
};

export const reportFieldValueChange = (field, value) => {
    return {
        type: REPORT_FIELD_VALUE_CHANGE,
        field,
        value,
    };
};

export const resetReportFieldValue = (field) => {
    return {
        type: REPORT_RESET_FIELD_VALUE,
        field,
    };
};

export const resetReportForm = () => {
    return {
        type: RESET_REPORT_FORM,
    };
};

export const getSettings = () => {
    let smr_enabled = store.getState().globalReducer.company.smr_enabled;
    const req = axios
        .get(`${getUrl("reportsConfig")}/v1/settings?access-token=${getAccessToken()}`)
        .then((res) => {
            //dispatch(gettingStartedProgress());

            let settings = res.data.data;

            if (smr_enabled !== 1) {
                settings = settings.filter((s) => s.system_name !== "smr_alert_keyword");
            }

            return settings;
        })
        .catch((err) => {
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    //dispatch(gettingStartedProgress());

    return {
        type: GET_SETTINGS,
        payload: req,
    };
};

export const getReportsList = () => {
    // https://api2stage.circussocial.com/v7/admin/reports/v1?access-token=v3-1cd69eaa3743d3514218e819d1050635
    const req = axios
        .get(`${getUrl("reportsConfig")}/v2?access-token=${getAccessToken()}`)
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err.response.data);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });
    //dispatch(gettingStartedProgress());

    return {
        type: GET_REPORTS_LIST,
        payload: req,
    };
};

export const getAlertsList = () => {
    // https://api2stage.circussocial.com/v7/admin/reports/v1?access-token=v3-1cd69eaa3743d3514218e819d1050635
    const req = axios({
        method: "GET",
        url: getUrl("alerts") + "/list-v2?access-token=" + getAccessToken(),
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((res) => {
            // console.log(res.data);
            return res.data.data;
        })
        .catch((err) => console.log(err));
    // dispatch(gettingStartedProgress());
    return {
        type: GET_ALERTS_LIST,
        payload: req,
    };
};

export const createReport = (data) => {
    const req = axios
        .post(`${getUrl("reportsConfig")}/v1?access-token=${getAccessToken()}`, data)
        .then((res) => {
            toast.success("Report created successfully");
            return res.data;
        })
        .catch((err) => {
            console.log(err.response.data);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });
    // dispatch(gettingStartedProgress());

    return {
        type: CREATE_REPORT,
        payload: req,
    };
};

export const updateReport = (data, id) => {
    const req = axios
        .patch(`${getUrl("reportsConfig")}/v1/${id}?access-token=${getAccessToken()}`, data)
        .then((res) => {
            toast.success("Report updated successfully");
            //dispatch(gettingStartedProgress());
            return res.data;
        })
        .catch((err) => {
            console.log(err.response.data);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: UPDATE_REPORT,
        payload: req,
    };
};

export const deleteReport = (id) => {
    const req = axios
        .delete(`${getUrl("reportsConfig")}/v1/${id}?access-token=${getAccessToken()}`)
        .then((res) => {
            toast.success("Report deleted successfully");
            return res.data;
        })
        .catch((err) => {
            console.log(err.response.data);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: DELETE_REPORT,
        payload: req,
    };
};

export const deleteReportPrompt = (id) => {
    return {
        type: DELETE_REPORT_PROMPT,
        payload: id,
    };
};

export const createAlert = (data, values) => {
    const req = axios
        .post(`${getUrl("reportsConfig")}/v1?access-token=${getAccessToken()}`, data)
        .then((res) => {
            // toast.success("Created successfully");
            if (!values.cloneToCollection) {
                toast.success(`Email alert created successfully`);
                return res.data;
            } else {
                const alertCreatedID = [+res.data.data.id];
                if (values.collectionData.collectionType === "new") {
                    const collectionData = {
                        name: values.collectionData.data.name,
                        tags: values.collectionData.data.tags,
                        collection_type: "synced",
                        alert_ids: alertCreatedID,
                    };
                    if (values.collectionData.data.visibility.value === "own") {
                        collectionData.access_type = "0";
                        collectionData.access_value = "";
                    } else if (values.collectionData.data.visibility.value === "team") {
                        collectionData.access_type = "2";
                        collectionData.access_value = values.collectionData.data.teams.map((t) => t.value).toString();
                    }
                    return axios
                        .post(`${getUrl("collection")}/create?access-token=${getAccessToken()}`, collectionData)
                        .then((response) => {
                            if (values.sendAsEmail)
                                toast.success(
                                    `You’ve successfully created an alert synced Collection – ${values.collectionData.data.name} for the alert ${values.alertName}. You will now receive email alerts and you can also find your collection under the Collaborate section.`,
                                );
                            else
                                toast.success(
                                    `You’ve successfully created an alert synced Collection – ${values.collectionData.data.name} for the alert ${values.alertName}. You can now find your collection under the Collaborate section.`,
                                );
                            //dispatch(gettingStartedProgress());
                            return response.data;
                        })
                        .catch((data) => {
                            if (values.sendAsEmail)
                                toast.error(
                                    `Error. Your request for alert and Collection creation could not be fulfilled. Please try again. If you are unable to proceed with creation even after multiple attempts, please get in touch with your Radarr representative .`,
                                );
                            else
                                toast.error(
                                    `Error. Your request for alert creation and Collection updating could not be fulfilled. Please try again. If you are unable to proceed with creation even after multiple attempts, please get in touch with your Radarr representative .`,
                                );
                            return data;
                        });
                } else if (values.collectionData.collectionType === "old") {
                    const collectionData = {
                        collection_id: values.collectionData.data.value,
                        collection_type: "synced",
                        alert_ids: values.collectionData.data.synced_alerts
                            .map((a) => {
                                return +a.alert_id;
                            })
                            .concat(alertCreatedID),
                    };
                    return axios
                        .post(`${getUrl("collection")}/update?access-token=${getAccessToken()}`, collectionData)
                        .then((response) => {
                            if (values.sendAsEmail)
                                toast.success(
                                    `You’ve successfully updated your Collection to an alert synced Collection – ${values.collectionData.data.name} for the alert ${values.alertName}. You can now find your collection under the Collaborate section.`,
                                );
                            else
                                toast.success(
                                    `You’ve successfully updated your Collection to an alert synced Collection – ${values.collectionData.data.name} for the alert ${values.alertName}. You can now find your collection under the Collaborate section.`,
                                );
                            return response.data;
                        })
                        .catch((data) => {
                            if (values.sendAsEmail)
                                toast.error(
                                    `Error. Your request for alert and Collection creation could not be fulfilled. Please try again. If you are unable to proceed with creation even after multiple attempts, please get in touch with your Radarr representative .`,
                                );
                            else
                                toast.error(
                                    `Error. Your request for alert creation and Collection updating could not be fulfilled. Please try again. If you are unable to proceed with creation even after multiple attempts, please get in touch with your Radarr representative .`,
                                );
                            return data;
                        });
                }
            }
        })
        .catch((err) => {
            console.log(err.response.data);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else
                toast.error(
                    "Error. Your request for alert creation could not be fulfilled. Please try again. If you are unable to proceed with creation even after multiple attempts, please get in touch with your Radarr representative .",
                );
            return err;
        });

    return {
        type: CREATE_ALERT,
        payload: req,
    };
};

export const updateAlert = (data, values, original, collectionsList) => {
    // console.log(values);
    // console.log(original);
    const req = axios
        .patch(`${getUrl("reportsConfig")}/v1/${original.id}?access-token=${getAccessToken()}`, data)
        .then((res) => {
            if (
                (!values.cloneToCollection && original.synced_collections.length === 0) ||
                (original.synced_collections.length !== 0 &&
                    values.cloneToCollection &&
                    values.collectionData.collectionType === "old" &&
                    values.collectionData.data.id === original.synced_collections[0].collection_id)
            ) {
                // condition for no collection added or if there was a collection attached it didn't get changed.
                toast.success("Alert Updated successfully.");
                return res.data;
            } else if (original.synced_collections.length !== 0 && !values.cloneToCollection) {
                // condition for there was a collection earlier but removed that and added no more collection
                // console.log(collectionsList);
                const originalCollection = collectionsList.filter((c) => c.id === original.synced_collections[0].collection_id)[0];
                // console.log(originalCollection);
                const originalCollectionAlerts = originalCollection.synced_alerts.filter((s) => s.alert_id !== original.id);

                let collectionData;
                if (originalCollectionAlerts.length > 0) {
                    collectionData = {
                        collection_id: originalCollection.id,
                        collection_type: "synced",
                        alert_ids: originalCollectionAlerts.map(function (a) {
                            return +a.alert_id;
                        }),
                    };
                } else {
                    collectionData = {
                        collection_id: originalCollection.id,
                        collection_type: "basic",
                        alert_ids: [],
                    };
                }
                return axios
                    .post(`${getUrl("collection")}/update?access-token=${getAccessToken()}`, collectionData)
                    .then((response) => {
                        toast.success(`Alert Updated successfully.`);
                        // console.log(response);
                        return response.data;
                    })
                    .catch((data) => {
                        toast.success("Alert Updated successfully.");
                        toast.error("Syncing to Collection Failed");
                        return data;
                    });
            } else {
                // condition when changed the existing collection or created a new one.

                const alertCreatedID = [+original.id];

                if (original.synced_collections.length > 0) {
                    // condition when there was a collection earlier and changed that to another existing one or created a new one
                    // console.log(collectionsList);
                    const originalCollection = collectionsList.filter((c) => c.id === original.synced_collections[0].collection_id)[0];
                    // console.log(originalCollection);
                    const originalCollectionAlerts = originalCollection.synced_alerts.filter((s) => s.alert_id !== original.id);

                    let collectionData;
                    if (originalCollectionAlerts.length > 0) {
                        collectionData = {
                            collection_id: originalCollection.id,
                            collection_type: "synced",
                            alert_ids: originalCollectionAlerts.map(function (a) {
                                return +a.alert_id;
                            }),
                        };
                    } else {
                        collectionData = {
                            collection_id: originalCollection.id,
                            collection_type: "basic",
                            alert_ids: [],
                        };
                    }
                    return axios
                        .post(`${getUrl("collection")}/update?access-token=${getAccessToken()}`, collectionData)
                        .then((response) => {
                            // toast.success(`Updated successfully.`);
                            // return response;

                            if (values.collectionData.collectionType === "new") {
                                const collectionData = {
                                    name: values.collectionData.data.name,
                                    tags: values.collectionData.data.tags,
                                    collection_type: "synced",
                                    alert_ids: alertCreatedID,
                                };
                                if (values.collectionData.data.visibility.value === "own") {
                                    collectionData.access_type = "0";
                                    collectionData.access_value = "";
                                } else if (values.collectionData.data.visibility.value === "team") {
                                    collectionData.access_type = "2";
                                    collectionData.access_value = values.collectionData.data.teams.map((t) => t.value).toString();
                                }
                                return axios
                                    .post(`${getUrl("collection")}/create?access-token=${getAccessToken()}`, collectionData)
                                    .then((response) => {
                                        toast.success("Alert Updated successfully.");
                                        return response.data;
                                    })
                                    .catch((data) => {
                                        toast.success("Alert Updated successfully.");
                                        toast.error("Syncing to Collection Failed");
                                        return data;
                                    });
                            } else if (values.collectionData.collectionType === "old") {
                                const collectionData = {
                                    collection_id: values.collectionData.data.value,
                                    collection_type: "synced",
                                    alert_ids: values.collectionData.data.synced_alerts
                                        .map((a) => {
                                            return +a.alert_id;
                                        })
                                        .concat(alertCreatedID),
                                };
                                return axios
                                    .post(`${getUrl("collection")}/update?access-token=${getAccessToken()}`, collectionData)
                                    .then((response) => {
                                        toast.success("Alert Updated successfully.");
                                        return response.data;
                                    })
                                    .catch((data) => {
                                        toast.success("Alert Updated successfully.");
                                        toast.error("Syncing to Collection Failed");
                                        return data;
                                    });
                            }
                        })
                        .catch((data) => {
                            toast.success("Alert Updated successfully.");
                            toast.error("Syncing to Collection Failed");
                            return data;
                        });
                } else {
                    // condition when there was no existing one but now added a newly created collection or an existing one.
                    if (values.collectionData.collectionType === "new") {
                        const collectionData = {
                            name: values.collectionData.data.name,
                            tags: values.collectionData.data.tags,
                            collection_type: "synced",
                            alert_ids: alertCreatedID,
                        };
                        if (values.collectionData.data.visibility.value === "own") {
                            collectionData.access_type = "0";
                            collectionData.access_value = "";
                        } else if (values.collectionData.data.visibility.value === "team") {
                            collectionData.access_type = "2";
                            collectionData.access_value = values.collectionData.data.teams.map((t) => t.value).toString();
                        }
                        return axios
                            .post(`${getUrl("collection")}/create?access-token=${getAccessToken()}`, collectionData)
                            .then((response) => {
                                toast.success("Alert Updated successfully.");
                                return response.data;
                            })
                            .catch((data) => {
                                toast.success("Alert Updated successfully.");
                                toast.error("Syncing to Collection Failed");
                                return data;
                            });
                    } else if (values.collectionData.collectionType === "old") {
                        const collectionData = {
                            collection_id: values.collectionData.data.value,
                            collection_type: "synced",
                            alert_ids: values.collectionData.data.synced_alerts
                                .map((a) => {
                                    return +a.alert_id;
                                })
                                .concat(alertCreatedID),
                        };
                        return axios
                            .post(`${getUrl("collection")}/update?access-token=${getAccessToken()}`, collectionData)
                            .then((response) => {
                                toast.success("Alert Updated successfully.");
                                return response.data;
                            })
                            .catch((data) => {
                                toast.success("Alert Updated successfully.");
                                toast.error("Syncing to Collection Failed");
                                return data;
                            });
                    }
                }
            }
        })
        .catch((err) => {
            console.log(err);
            console.log(err.response.data);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: UPDATE_ALERT,
        payload: req,
    };
};

export const editReport = (id) => {
    return {
        type: EDIT_REPORT,
        payload: id,
    };
};

export const editReportValues = (values) => {
    return {
        type: EDIT_REPORT_VALUES,
        payload: values,
    };
};

export const editAlert = (id) => {
    return {
        type: EDIT_ALERT,
        payload: id,
    };
};

export const editAlertValues = (values) => {
    return {
        type: EDIT_ALERT_VALUES,
        payload: values,
    };
};

export const disableAlert = (alert) => {
    // console.log(alert);
    return {
        type: DISABLE_ALERT,
        payload: alert,
    };
};

export const enableOrDisableAlert = (alert, status) => {
    const req = axios
        .post(getUrl("alerts") + "/enableOrDisable?access-token=" + getAccessToken(), {
            alert_id: alert,
            action: status,
        })
        .then((res) => {
            // console.log(res.data);
            return res.data.data;
        })
        .catch((err) => console.log(err));

    return {
        type: ENABLE_OR_DISABLE_ALERT,
        payload: req,
    };
};

export const setDefaultEmail = (email) => {
    return {
        type: SET_DEFAULT_EMAIL,
        payload: email,
    };
};
